module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }